import { render, staticRenderFns } from "./UpdateLinkedinChannel.vue?vue&type=template&id=32accc38&scoped=true"
import script from "./UpdateLinkedinChannel.vue?vue&type=script&lang=js"
export * from "./UpdateLinkedinChannel.vue?vue&type=script&lang=js"
import style0 from "./UpdateLinkedinChannel.vue?vue&type=style&index=0&id=32accc38&prod&lang=scss&scoped=true"
import style1 from "./UpdateLinkedinChannel.vue?vue&type=style&index=1&id=32accc38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32accc38",
  null
  
)

export default component.exports